import React from 'react';
import '../styles/Body.css';
// import TutorCard from './TutorCard';
import FilterBodyComponent from "./FilterBodyComponent";
import WhyUsCard from "./WhyUsCard";
import {Box} from "@mui/material";
import Divider from "@mui/material/Divider";

// import InfoBoxes from './InfoBoxes';
// import Stack from '@mui/material/Stack';


const LandingBody = () => {
    return (
        <>
            <div>
                <FilterBodyComponent/>
            </div>
            <Box sx={{display: {xs: 'block', sm: 'none', md: 'none', lg: 'none'}}}>
                <Divider  variant='middle' sx={{ marginTop: '4rem', fontSize: '14px', fontWeight: 400}}>Why us</Divider>
                <WhyUsCard/>
            </Box>
        </>
    );
};

export default LandingBody;